import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';
import { healthCheckParam } from './urls/RouteUrls';

const GenerateHealthCheckPage = lazy(
	() => import('pages/healthcheck/GenerateHealthCheckPage')
);

const ViewHealthCheckPage = lazy(
	() => import('pages/healthcheck/ViewHealthCheckPage')
);

export const getHealthCheckRoutes = (): React.JSX.Element[] => [
	<Route
		key={'generateHealthCheck'}
		path={`${healthCheckParam}?/generate`}
		element={
			<LazyRouteElement
				area={createArea(AreaName.HealthCheck, OperationType.Create)}
				Component={GenerateHealthCheckPage}
				path="generate"
			/>
		}
	/>,
	<Route
		key={'viewHealthCheck'}
		path={`${healthCheckParam}/view`}
		element={
			<LazyRouteElement
				area={createArea(AreaName.HealthCheck, OperationType.Read)}
				Component={ViewHealthCheckPage}
				path={`${healthCheckParam}/view`}
			/>
		}
	/>,
];
